import { render, staticRenderFns } from "./ServiceType.vue?vue&type=template&id=882d6404&scoped=true"
import script from "./ServiceType.vue?vue&type=script&lang=js"
export * from "./ServiceType.vue?vue&type=script&lang=js"
import style0 from "./ServiceType.vue?vue&type=style&index=0&id=882d6404&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "882d6404",
  null
  
)

export default component.exports